import { DOMAIN_CONFIG } from '../configs/main';
import { initializeTracking } from './trackingUtils';

export const updateFavicon = (faviconPath) => {
  const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
  existingFavicons.forEach(link => link.remove());

  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = faviconPath;
  document.head.appendChild(link);
};

export const updateManifest = (manifestPath) => {
  const existingManifest = document.querySelector('link[rel="manifest"]');
  if (existingManifest) {
    existingManifest.remove();
  }

  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = manifestPath;
  document.head.appendChild(link);
};

export const updateTitle = (title) => {
  document.title = title;
};

export const updateAppleTouchIcon = (iconPath) => {
  const existingIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (existingIcon) {
    existingIcon.remove();
  }

  const link = document.createElement('link');
  link.rel = 'apple-touch-icon';
  link.href = iconPath;
  document.head.appendChild(link);
};

export const applyDomainConfig = (config = DOMAIN_CONFIG) => {
  updateTitle(config.title);
  updateFavicon(config.faviconPath);
  updateManifest(config.manifestPath);
  updateAppleTouchIcon(config.logoPath);
  initializeTracking(config);
};

export const initializeDomainConfig = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyDomainConfig());
  } else {
    applyDomainConfig();
  }
}; 